import {StyleRepository} from '@domain/model/Style/StyleRepository';

const DeleteQuizSegment = (repository: StyleRepository): Promise<void> => repository.deleteQuizSegment();

export {DeleteQuizSegment};
